<template>
  <z-tabs v-model="currentTab" :tabs="tabs" @change="setTab" />
  <div v-if="currentTab === 'Network'">
    <network-tree ref="locations" :firm="firm" @changed="changed" />
  </div>
  <div v-if="currentTab === 'Membership'">
    <member-listing ref="providerMembership" />
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { locationStore } from '@/stores/location'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import NetworkTree from './NetworkTree.vue'
import MemberListing from './MemberListing.vue'
export default {
  name: 'LocationProvider',
  components: {
    ZTabs,
    NetworkTree,
    MemberListing
  },
  props: {
    firm: Object
  },
  data() {
    return {
      currentTab: ''
    }
  },
  emits: ['changed'],
  computed: {
    ...mapState(locationStore, ['location']),
    tabs() {
      let _tabs = []
      if (this.isProvider && !this.isCalCopilot) {
        _tabs = ['Membership']
        this.setTab('Membership')
      } else {
        _tabs = ['Network', 'Membership']
        this.setTab('Network')
      }
      return _tabs
    },
    isProvider() {
      let _is = false
      if (this.location) {
        if (this.location.firmClass === 5) {
          _is = true
        }
      }
      return _is
    },
    isCalCopilot() {
      let _is = false
      if (this.location) {
        if (this.location.isCalCopilot) {
          _is = true
        }
      }
      return _is
    }
  },
  methods: {
    setTab(tab) {
      this.currentTab = tab
    },
    changed() {
      this.$emit('changed')
    },
    async save() {
      return await this.$refs.locations.save()
    }
  }
}
</script>
